export default __webpack_public_path__ + "static/media/LocationIntelligence.deea476f.svg";